"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveSettings = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const Yup = __importStar(require("yup"));
const PreferencesContext_1 = require("../context/PreferencesContext");
const FormikInput_1 = __importDefault(require("../elements/formik/FormikInput"));
const Context_1 = require("../elements/popup/Alert/Context");
const ConfirmDialog_1 = __importDefault(require("../elements/popup/Modal/ConfirmDialog"));
const schema = Yup.object().shape({
    workspaceName: Yup.string().required(),
});
const WorkspaceAddForm = (0, react_1.forwardRef)(({ className, message, onSave }, ref) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsx)("p", { style: { paddingBottom: '10px' }, children: message }), (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: { workspaceName: '' }, validationSchema: schema, onSubmit: onSave, innerRef: ref, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "workspaceName", placeholder: "Enter workspace Name", style: {
                        input: {
                            height: '35px',
                            width: '90%',
                            fontWeight: 'normal',
                            color: 'black',
                        },
                    }, autoFocus: true }) })] }));
});
function useSaveSettings() {
    const alert = (0, Context_1.useAlert)();
    const [isOpenDialog, openDialog, closeDialog] = (0, ui_1.useOnOff)(false);
    const settingsRef = (0, react_1.useRef)();
    const { dispatch, current } = (0, PreferencesContext_1.usePreferences)();
    const formRef = (0, react_1.useRef)(null);
    function addNewWorkspace({ workspaceName }) {
        dispatch({
            type: 'ADD_WORKSPACE',
            payload: {
                workspaceKey: workspaceName,
                data: settingsRef.current,
            },
        });
        closeDialog();
        alert.success('Preferences saved successfully');
    }
    return {
        saveSettings: (values) => {
            settingsRef.current = values;
            if (current.source !== 'user') {
                openDialog();
            }
            else {
                dispatch({
                    type: 'SET_PREFERENCES',
                    ...(values && { payload: values }),
                });
                closeDialog();
            }
        },
        SaveSettingsModal: () => {
            const alertConfig = {
                message: 'Please enter a new user workspace name in order to save your changes locally',
                render: (props) => ((0, jsx_runtime_1.jsx)(WorkspaceAddForm, { ...props, onSave: addNewWorkspace, ref: formRef })),
                buttons: [
                    {
                        text: 'Save',
                        handler: () => {
                            void formRef.current?.submitForm();
                        },
                        preventClose: true,
                    },
                    { text: 'Cancel' },
                ],
                id: 'save-workspace-dialog',
                onClose: closeDialog,
            };
            return ((0, jsx_runtime_1.jsx)(ui_1.Modal, { hasCloseButton: true, isOpen: isOpenDialog, onRequestClose: closeDialog, children: (0, jsx_runtime_1.jsx)(ConfirmDialog_1.default, { ...alertConfig }) }));
        },
    };
}
exports.useSaveSettings = useSaveSettings;
